import { getStoredTokenExp } from './auth/tokenStorage'

export default function () {
  const expToken = getStoredTokenExp()
  const isExpired = expToken ? Date.now() >= expToken * 1000 : true

  return isExpired
}
